import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// リクエストインターセプター
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 認証API
export const authAPI = {
  getGoogleAuthUrl: (role) => api.get(`/auth/google?role=${role}`),
  getCurrentUser: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout')
};

// レッスンAPI
export const lessonsAPI = {
  getCourses: () => api.get('/lessons/courses'),
  getCourse: (id) => api.get(`/lessons/courses/${id}`),
  getLesson: (id) => api.get(`/lessons/${id}`),
  createCourse: (data) => api.post('/lessons/courses', data),
  createLesson: (data) => api.post('/lessons', data),
  getVocabulary: (params) => api.get('/lessons/vocabulary/list', { params }),
  getVocabularyProgress: () => api.get('/lessons/vocabulary/progress'),
  reviewVocabulary: (data) => api.post('/lessons/vocabulary/review', data)
};

// ユーザーAPI
export const usersAPI = {
  getTeachers: () => api.get('/users/teachers'),
  getStudents: () => api.get('/users/students'),
  getUser: (id) => api.get(`/users/${id}`),
  updateProfile: (data) => api.put('/users/profile', data),
  getNotifications: () => api.get('/users/notifications/list'),
  markNotificationRead: (id) => api.put(`/users/notifications/${id}/read`),
  getProgressSummary: () => api.get('/users/progress/summary')
};

// MeetAPI
export const meetAPI = {
  createLesson: (data) => api.post('/meet/create-lesson', data),
  bookLesson: (data) => api.post('/meet/book', data),
  getBookings: (params) => api.get('/meet/bookings', { params }),
  getBooking: (id) => api.get(`/meet/bookings/${id}`),
  cancelBooking: (id) => api.put(`/meet/bookings/${id}/cancel`),
  completeBooking: (id, data) => api.put(`/meet/bookings/${id}/complete`, data),
  createInstantMeet: (data) => api.post('/meet/instant', data)
};

// カレンダーAPI
export const calendarAPI = {
  getEvents: (params) => api.get('/calendar/events', { params }),
  createEvent: (data) => api.post('/calendar/events', data),
  updateEvent: (id, data) => api.put(`/calendar/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/calendar/events/${id}`),
  getTeacherAvailability: (teacherId, date, params = {}) =>
    api.get(`/calendar/availability/${teacherId}`, { params: { date, ...params } })
};

// Billing API
export const billingAPI = {
  getStatus: () => api.get('/billing/status'),
  getPublishableKey: () => api.get('/billing/publishable-key'),
  createSetupIntent: () => api.post('/billing/setup-intent'),
  confirmSetup: (data) => api.post('/billing/confirm-setup', data),
  getMonthlySummary: (params) => api.get('/billing/monthly-summary', { params }),
  getHistory: () => api.get('/billing/history'),
  createPaymentIntent: (data) => api.post('/billing/create-payment-intent', data),
  confirmPayment: (data) => api.post('/billing/confirm-payment', data)
};
